<script>
    import { onMount } from "svelte";

    let search_str = "";
    let rtdata_display = "";
    let bFound = false;

    // 提示框配置
    toastr.options = {
        positionClass: "toast-top-center",
    };

    // 加载事件函数
    onMount(() => {
        //loadDevices();
    });

    /*
    function loadDevices() {
        let tmpUrl = "/rtapi/getdevlist";
        jQuery.ajax({
            type: "get",
            url: tmpUrl,
            success: function (response) {
                if (response.code == 200) {
                    if (Array.isArray(response.result)) {
                        devcodes = response.result;
                        totalcount = devcodes.length;
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
        });
    }
    */

    function showRtdata() {
        if (search_str.trim() == "") {
            return;
        }
        rtdata_display = "";
        bFound = false;
        let tmpUrl1 = "/rtapi/getdevrtdatas?code=" + search_str;
        let tmpUrl2 = "/rtapi/getdevregdatas?code=" + search_str;
        // 实时数据
        jQuery.ajax({
            type: "get",
            url: tmpUrl1,
            success: function (response) {
                if (response.code == 200) {
                    let robj = response.result;
                    //console.log(robj);
                    let sHtml = "";
                    if (robj.devcode == undefined) {
                        sHtml = "<li>找不到数据</li>";
                    } else {
                        sHtml += "<li>设备号：" + robj.devcode + "</li>";
                        sHtml += "<li>更新时间：" + robj.lastupdate + "</li>";
                        if (robj.props != undefined) {
                            if (robj.props.length > 0) {
                                // 显示删除操作
                                bFound = true;
                            }
                            for (let i=0;i<robj.props.length;i++)
                            {
                                sHtml +=  ("<li>" + robj.props[i].propertyname + "：" + robj.props[i].rtval + "</li>")
                            }
                        }
                        // 注册数据
                        jQuery.ajax({
                            type: "get",
                            url: tmpUrl2,
                            success: function (response2) {
                                let robj2 = response2.result;
                                //console.log(robj2);
                                if (robj2.props != undefined) {
                                    if (robj.props.length > 0) {
                                        // 显示删除操作
                                        bFound = true;
                                    }
                                    for (let i=0;i<robj2.props.length;i++)
                                    {
                                        sHtml +=  ("<li>" + robj2.props[i].propertyname + "：" + robj2.props[i].rtval + "</li>")
                                        rtdata_display = sHtml
                                    }
                                }
                            }
                        });
                    }
                    rtdata_display = sHtml
                    jQuery("#rtdata-modal").modal("show");
                } else {
                    toastr.error("调取实时数据错误:");
                }
            },
            error: function (err) {
                console.log(err);
                toastr.error("调取实时数据异常:");
            },
        });
    }

    function clearDeviceData() {
        if (search_str.trim() == "") {
            return;
        }
        if (confirm("此操作将清除数据，是否继续？") == true) {
            let tmpUrl = "/rtapi/cleardevicedata?selfid=" + search_str;
            jQuery.ajax({
                type: "get",
                url: tmpUrl,
                success: function (response) {
                    if (response.code == 200) {
                        toastr.info("数据清除成功")
                    } else {
                        toastr.error("数据清除失败");
                    }
                },
                error: function (err) {
                    toastr.error("数据清除错误" + err);
                },
            });
        }
    }

</script>

<!-- Content Wrapper. Contains page content -->
<div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
        <div class="container-fluid">
            <div class="row mb-2">
                <div class="col-sm-6">
                    <h1>数据清除</h1>
                </div>
                <div class="col-sm-6">
                    <ol class="breadcrumb float-sm-right">&nbsp;</ol>
                </div>
            </div>
        </div>
    </section>
    <!-- Main content -->
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <!-- card -->
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">强制清除设备数据</h3>
                            <div class="card-tools">
                                &nbsp;
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row" style="padding-bottom:20px">
                                <input type="search" bind:value={search_str} style="width:300px" placeholder="输入准确的设备号"/>
                                <button type="submit" class="btn btn-default" on:click={showRtdata}>
                                    <i class="bi bi-search"></i>
                                     检索
                                </button>
                            </div>
                            <div class="row" style="height:550px">
                                <ul>{@html rtdata_display}</ul>
                                <br>
                                {#if bFound==true}
                                <span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                    <a class="operation_link" href={"javascript:;"} on:click={clearDeviceData} > 强制清除 </a>
                                </span>
                                {/if}
                            </div>
                        </div>
                    </div>
                    <!-- end of card -->
                </div>
            </div>
        </div>
    </section>
</div>

<style>
    .operation_link {
        color: #383838;
        cursor: pointer;
    }
    .operation_link:hover {
        color: blue;
    }
</style>
